import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {
  useGetJobDetailsQuery,
  useGetCandidateListByJobQuery,
} from '../api/employer';
import AddCandidateInJobModal from '../components/jobBoard/AddCandidateInJobModal';
import Board from '../components/jobBoard/Board';
import JobBoardHeader from '../components/jobBoard/JobBoardHeader';
import Button from '../components/ui/Button';

const JobManagement = () => {
  const {jobId} = useParams();
  const [addCandidateModal, setAddCandidateModal] = useState(false);
  const [reasonModal, setReasonModal] = useState(false);
  const [declineModal, setDeclineModal] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const [jobDetails, setJobDetails] = useState({});
  const [candidateDetails, setCandidateDetails] = useState({});

  // Job Details
  const {
    data: jobDetailsResponse,
    isLoading: isJobDetailsLoading,
    error: jobDetailsError,
  } = useGetJobDetailsQuery(jobId);

  // Candidate Listing
  const {
    data: {data: candidateList} = {data: null},
    isLoading: isCandidateListLoading,
    error: candidateListError,
  } = useGetCandidateListByJobQuery(jobId);

  useEffect(() => {
    let newData = {};
    (candidateList || []).map((item) => {
      switch (item?._id) {
        case 1:
          newData = {...newData, 1: [...(item?.candidates || [])]};
          break;
        case 2:
          newData = {...newData, 2: [...(item?.candidates || [])]};
          break;
        case 3:
          newData = {...newData, 3: [...(item?.candidates || [])]};
          break;
        case 4:
          newData = {...newData, 4: [...(item?.candidates || [])]};
          break;
        case 5:
          newData = {...newData, 5: [...(item?.candidates || [])]};
          break;
        case 6:
          newData = {...newData, 6: [...(item?.candidates || [])]};
          break;
        case null:
          newData = {
            ...newData,
            applied: [
              ...(item?.candidates || []).filter((item) => !item.declined),
            ],
          };
          newData = {
            ...newData,
            declined: [
              ...(item?.candidates || []).filter((item) => item.declined),
            ],
          };
      }
    });

    setCandidateDetails(newData);
  }, [candidateList]);

  useEffect(() => {
    if (jobDetailsResponse?.data) {
      const allJobData = jobDetailsResponse?.data;
      let count =
        allJobData.inbox +
        allJobData.review +
        allJobData.inProgress +
        allJobData.offered +
        allJobData.hired +
        allJobData.rejected +
        allJobData.declined;

      setJobDetails({...allJobData, candidateCount: count});
      setIsDeleted(allJobData.isDeleted);
    }
  }, [jobDetailsResponse]);

  if (isJobDetailsLoading || isCandidateListLoading) return 'Loading...';
  if (candidateListError || jobDetailsError) return 'Something went wrong..';

  const candidateCount = jobDetails?.candidateCount || 0;

  return (
    <div className="px-8 py-6">
      <JobBoardHeader
        jobDetails={jobDetails}
        count={candidateList?.applied?.length}
      />

      <div className="py-10">
        <div className="flex-between-center">
          <div className="text-2xl font-medium">
            Candidates ({candidateCount})
          </div>
          <div className="flex gap-4">
            <Button onClick={() => setAddCandidateModal(true)}>
              + Add Candidate
            </Button>
          </div>
        </div>
      </div>

      <div className="w-full">
        <Board
          jobLoading={isJobDetailsLoading}
          jobDetails={jobDetails}
          candidateDetails={candidateDetails}
          setCandidateDetails={setCandidateDetails}
          reasonModal={reasonModal}
          setReasonModal={setReasonModal}
          setAddCandidateModal={setAddCandidateModal}
        />
      </div>

      {!isDeleted && (
        <AddCandidateInJobModal
          isOpen={addCandidateModal}
          onClose={() => setAddCandidateModal(false)}
          data={candidateDetails?.applied}
          declineModal={declineModal}
          setDeclineModal={setDeclineModal}
        />
      )}
    </div>
  );
};

export default JobManagement;
